// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#group_box[data-v-f1a79cea] {\n  background-color: #171921;\n  border: 1px solid #6A6A6A;\n  color: white;\n  border-radius: 5px;\n  max-width: 700px;\n}\n#group_box_title[data-v-f1a79cea] {\n  border-bottom: 1px solid #6A6A6A;\n  position: relative;\n}\n#close_btn[data-v-f1a79cea] {\n  position: absolute;\n  top: 5px;\n  right: 15px;\n}", ""]);
// Exports
module.exports = exports;
